import { gql } from '@apollo/client';

import {
  AddFormMessageDocument,
  type AddFormMessageMutation,
  type AddFormMessageMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation AddFormMessage($input: AddFormMessageInput!) {
      addFormMessage(input: $input) {
        message {
          id
          text
          createdAt
          sender
          transcript
          contentUrl
          assets {
            id
            name
            url
            description
            createdAt
            updatedAt
          }
        }
        surveyProgress
      }
    }
  `;
}

export const ADD_FORM_MESSAGE = AddFormMessageDocument;
export type { AddFormMessageMutation, AddFormMessageMutationVariables };
